import React from 'react';
import { AccordionProps } from 'src/components/oneCorp/features/MealCredit/common/Accordion/Accordion';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { AccordionRule } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRule';
import { LocationsRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/LocationsRuleHeader';
import { withRow } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/withRow';
import {
  SelectLocations,
  SelectLocationsProps,
} from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/LocationsRule/SelectLocations';

const maxLocationsAllowed = 300;

export type LocationsRuleProps = Omit<AccordionProps, 'header' | 'body'>;

const SelectLocationsWithRow = withRow<SelectLocationsProps>(SelectLocations);

export function LocationsRule({ ...props }: LocationsRuleProps): JSX.Element {
  const {
    mealCredit,
    formValues: { hasLocation },
  } = useMealCreditFormData();

  return (
    <AccordionRule
      {...props}
      header={(isActive): JSX.Element => (
        <LocationsRuleHeader isActive={isActive} />
      )}
      body={(isActive): JSX.Element => (
        <SelectLocationsWithRow
          isActive={isActive}
          hasLocation={hasLocation}
          maxLocationsAllowed={maxLocationsAllowed}
          submittedLocationSelections={mealCredit?.locations}
        />
      )}
    />
  );
}
